import { all, takeLatest, call, put } from "redux-saga/effects";
import api from "../../../services/api";
import { updateColaboradores, updateComponent } from "./actions";
import types from "./types";

export function* fetchColaboradores() {
    try {
        // Atualizar o estado para "carregando"
        yield put(updateComponent({ loading: true, error: null }));

        const response = yield call(api.get, "/colaborador");

        if (response.data.error) {
            throw new Error("Erro ao buscar colaboradores: " + response.data.message);
        }

        // Atualizar a lista de colaboradores
        yield put(updateColaboradores(response.data.colaboradores));
    } catch (err) {
        console.error(err);
        // Atualizar o estado de erro
        yield put(updateComponent({ loading: false, error: "Erro ao carregar os colaboradores." }));
    }
}

export default all([
    takeLatest(types.FETCH_COLABORADORES, fetchColaboradores),
]);
